import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// NOTE: the Sentry `feedbackIntegration` was removed — its feedback SUBMISSION
// posted to Sentry's ingest endpoint, which users' ad-blockers block (real
// feedback was silently lost). Product feedback now submits same-origin via
// FeedbackProvider → /org/:orgSlug/feedback. Sentry stays for error + replay.

init({
  dsn: ENV.SENTRY_DSN,
  tracesSampleRate: 1,
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      mask: ['input[type="password"]'],
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
